import { Resource as i, API as a } from "@coveo/platform-client";
const t = class t extends i {
  list(r) {
    return this.api.get(
      this.buildPath(`${t.baseUrl}`, r)
    );
  }
  get(r, s) {
    return this.api.get(
      this.buildPath(`${t.baseUrl}/${r}`, s)
    );
  }
  getProductsMetrics(r, s) {
    return this.api.get(
      this.buildPath(`${t.baseUrl}/${r}/products`, s)
    );
  }
};
t.baseUrl = `/rest/organizations/${a.orgPlaceholder}/commerce/reports/v1/recommendations/slots`;
let e = t;
export {
  e as RecommendationsMetrics
};
//# sourceMappingURL=RecommendationsMetrics.js.map
